import { Injectable } from '@angular/core';
import { ProjectGetAllDto, ProjectTeamGetAllDto, UserListDto } from '@shared/service-proxies/service-proxies';
import { Subject } from 'rxjs';

export const PROJECT_MANAGER_ROLE = 'Project Manager';
export const PROGRAM_MANAGER_ROLE = 'Program Manager';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  navFromDetailpageObs = new Subject<void>();
  navigatedFromDatailPage : boolean;

  nameArray: any;
  
  getCardList() {
    return this.nameArray;
  }

  createCard(data: any) {
    if (data.length !== 0) this.nameArray = data;
  }

  constructor() { }

  getFullname(name: string, lastname: string) {
    return name + " " + lastname;
  }

  // The assigned managers are returned as their own objects, so they are matched back to the
  // supplied dropdown options by id, falling back to the team member holding the manager role.
  resolveAssignedProgramManager(project: ProjectGetAllDto, dropdownOptions: UserListDto[] = []): UserListDto {
    const programManagerId = project?.assignedProgramManagerData?.id
      || project?.assignedProgramManager
      || project?.teamMembers?.find(x => x.projectRole === PROGRAM_MANAGER_ROLE)?.userId;

    if (!programManagerId) return null;

    const programManager = dropdownOptions.find(x => x.id === programManagerId)
      ?? project.assignedProgramManagerData
      ?? this.mapTeamMemberToUser(project.teamMembers?.find(x => x.userId === programManagerId));

    return this.ensureUserDisplayName(programManager);
  }

  resolveAssignedProjectManagers(project: ProjectGetAllDto, dropdownOptions: UserListDto[] = []): UserListDto[] {
    const fromAssigned = (project?.assignedProjectManager ?? []).map(x => x.id);
    const fromTeam = (project?.teamMembers ?? [])
      .filter(x => x.projectRole === PROJECT_MANAGER_ROLE)
      .map(x => x.userId);
    const assignedIds = [...fromAssigned, ...fromTeam]
      .filter((id, index, ids) => id != null && ids.indexOf(id) === index);

    return assignedIds
      .map(id => dropdownOptions.find(x => x.id === id)
        ?? project.assignedProjectManager?.find(x => x.id === id)
        ?? this.mapTeamMemberToUser(project.teamMembers?.find(x => x.userId === id)))
      .filter(manager => !!manager)
      .map(manager => this.ensureUserDisplayName(manager));
  }

  includeAssignedUsers(dropdownOptions: UserListDto[], assignedUsers: UserListDto[]): UserListDto[] {
    const options = [...(dropdownOptions ?? [])];
    (assignedUsers ?? []).filter(user => user?.id).forEach(user => {
      if (!options.some(x => x.id === user.id)) {
        options.unshift(this.ensureUserDisplayName(user));
      }
    });
    return options;
  }

  includeAssignedTeamMembers(dropdownOptions: UserListDto[], assignedMembers: ProjectTeamGetAllDto[]): UserListDto[] {
    const options = [...(dropdownOptions ?? [])];
    (assignedMembers ?? []).forEach(member => {
      if (!member?.userId) return;
      const alreadyPresent = options.some(user =>
        user.id === member.userId || (user as UserListDto & { userId?: number }).userId === member.userId);
      if (!alreadyPresent) {
        options.unshift(this.mapTeamMemberToUser(member));
      }
    });
    return options;
  }

  private mapTeamMemberToUser(member: ProjectTeamGetAllDto): UserListDto {
    if (!member) return null;
    const fullName = (member.fullName || `${member.name || ''} ${member.surname || ''}`).trim();
    return UserListDto.fromJS({
      id: member.userId,
      name: member.name,
      surname: member.surname,
      fullName,
      emailAddress: member.emailAddress,
      profileImage: member.profileImage,
      roles: []
    });
  }

  private ensureUserDisplayName(user: UserListDto): UserListDto {
    if (!user) return user;
    if (!user.fullName?.trim()) {
      (user as any).fullName = `${user.name || ''} ${user.surname || ''}`.trim();
    }
    return user;
  }

  showTooltip(name:string, num:number){
    return name.length > num ? true : false;
  }
  
  selectedIndexTab: any;
  setHelpCardData(index: any){
    return index
  }

  projectType: number;
  setProjectId(type: number)
  {
    this.projectType = type;
  }
  getProjectid()
  {
    return this.projectType;
  }

}
